export default function getRecordType (id, {educators, schools, students, districts, classes}) {
  if (districts[id]) {
    return {recordType: 'District', record: districts[id]}
  } else if (schools[id]) {
    return {recordType: 'School', record: schools[id]}
  } else if (classes[id]) {
    return {recordType: 'Class', record: classes[id]}
  } else if (students[id]) {
    return {recordType: 'Student', record: students[id]}
  } else if (educators[id]) {
    return {recordType: educators[id].role, record: educators[id]}
  } else {
    return {recordType: '', record: null}
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/getRecordType.js